import "./styles/ModalWindow.css";
import "./styles/InsideDomino.css";
import { IContentDomino } from "./DominoesMassive";
export interface PropsInsideDomino {
  content: IContentDomino;
  isFree?: boolean;
  isModalWindow?: boolean;
}

/** Content of each domino */
export const InsideDomino = ({
  content,
  isFree = false,
  isModalWindow = false,
}: PropsInsideDomino) => {
  return (
    <>
      {/*If isFree=== true, this is free play zone (without content)*/}
      {!isFree && (
        <>
          <div
            className={
              isModalWindow
                ? "text-first-half-domino-for-modal-window" +
                  (content.firstComponent === " "
                    ? " rect-first-last-domino"
                    : "")
                : "text-first-half-domino"
            }
          >
            {content.firstComponent}
          </div>

          <div
            className={
              isModalWindow
                ? "rect-inside-domino-for-modal-window"
                : "rect-inside-domino"
            }
          ></div>

          <div
            className={
              isModalWindow
                ? "text-second-half-domino-for-modal-window" +
                  (content.secondComponent === " "
                    ? " rect-first-last-domino"
                    : "")
                : "text-second-half-domino"
            }
          >
            {content.secondComponent}
          </div>
        </>
      )}
    </>
  );
};
